import * as React from 'react'
import classNames from 'classnames'
import { accentUtils, newGuid } from './../services/HelperService';
import { AccentTooltip } from '../controls/AccentTooltip'
import { TbLayoutKanban, TbLibraryPhoto } from 'react-icons/tb'

// A react-icons glyph with the same container, padding, cursor and accessible-name
// behaviour as the Material `Icon` above, so the two kinds can sit side by side.
const ReactIcon = ({ glyph: Glyph, iconRef, top, left, style, onClick, disabled, noPadding, ariaLabel, toolTipText, className, size = 18 }) => {
    const isBtn = !accentUtils.isNull(onClick);
    const name = !accentUtils.isEmpty(ariaLabel) ? ariaLabel : typeof toolTipText === "string" && toolTipText.length > 0 ? toolTipText : undefined;
    const a11y = accentUtils.isNull(name)
        ? { "aria-hidden": true }
        : { "aria-label": name, role: isBtn ? "button" : "img", "aria-disabled": isBtn && disabled ? true : undefined };
    return (
        <div className={classNames("acc-icon-containter", { "p-2": isBtn && !noPadding })} ref={iconRef}>
            <Glyph
                size={size}
                className={classNames("icon", className)}
                style={{
                    position: 'relative',
                    top: !accentUtils.isEmpty(top) ? `${top}px` : 'unset',
                    left: !accentUtils.isEmpty(left) ? `${left}px` : 'unset',
                    cursor: disabled ? 'no-drop' : isBtn ? 'pointer' : undefined,
                    opacity: disabled ? 0.5 : 1,
                    ...style
                }}
                onClick={disabled ? undefined : onClick}
                {...a11y}
            />
        </div>
    );
};

class Icon extends React.Component {

    constructor(props) {
        super(props);

        this.id = this.props.id;

        if (accentUtils.isNull(this.id)) {
            this.id = 'id_' + newGuid();
        }

    }


    render() {

        var toolTip = null;


        if (!accentUtils.isNull(this.props.toolTipHtml)) {
            toolTip = <AccentTooltip target={this.id} html={this.props.toolTipHtml} style={this.props.toolTipStyle} />;
        }
        if (!accentUtils.isNull(this.props.toolTipText)) {
            toolTip = <AccentTooltip target={this.id} text={this.props.toolTipText} style={this.props.toolTipStyle} />;
        }

        const imgSrc = this.props.img;
        const materialSrc = this.props.matrial;
        const isBtn = !accentUtils.isNull(this.props.onClick);

        const containerClass = classNames(
            "acc-icon-containter",
            {
                "p-2" : isBtn && !this.props.noPadding
            });

        var className = classNames(
            'icon',
            {                
                'material-icons md-18': !accentUtils.isNull(materialSrc) && !this.props.outlined,
                'material-icons-outlined md-18': !accentUtils.isNull(materialSrc) && this.props.outlined,
            });
        

        const style = {
            position: "relative",
            top: !accentUtils.isEmpty(this.props.top) ? `${this.props.top}px` : "unset",
            left: !accentUtils.isEmpty(this.props.left) ? `${this.props.left}px` : "unset",
            cursor: this.props.disabled? "no-drop" :  isBtn ? "pointer" : undefined,
            maxHeight: this.props.maxHeight,
            maxWidth: this.props.maxWidth, 
            opacity: this.props.disabled ? 0.5 : 1,
            ...this.props.style
        };


        // The accessible name. A material glyph is a ligature — without a name,
        // assistive technology reads the raw token ("more_horiz", "curtains").
        // ariaLabel wins; a plain-text tooltip is the next best description.
        const ariaLabel = !accentUtils.isEmpty(this.props.ariaLabel)
            ? this.props.ariaLabel
            : typeof this.props.toolTipText === "string" && this.props.toolTipText.length > 0 ? this.props.toolTipText : undefined;
        const a11y = accentUtils.isNull(ariaLabel)
            ? {}
            : { "aria-label": ariaLabel, role: isBtn ? "button" : "img", "aria-disabled": isBtn && this.props.disabled ? true : undefined };

        return (
            <div className={containerClass} ref={ this.props.iconRef} >
                {toolTip}
                {imgSrc && <img className={className} style={style} id={this.id} onClick={this.props.disabled ? undefined : this.props.onClick} onMouseEnter={this.props.onMouseEnter} onMouseLeave={this.props.onMouseLeave} src={ imgSrc} alt={ariaLabel ?? ""} />}
                {materialSrc && <i className={className} style={style} id={this.id} onClick={this.props.disabled ? undefined : this.props.onClick} onMouseEnter={this.props.onMouseEnter} onMouseLeave={this.props.onMouseLeave} {...a11y}>{materialSrc}</i>}                
            </div>
        );
    }

}


const AccentIcons = {
    ArrowDown: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "arrow_downward" }} />),
    ArrowUp: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "arrow_upward" }} />),
    Attach: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "attach_file" }} />),
    BellActive: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "notifications_active" }} />),
    Bell: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "notifications" }} />),
    Bolt: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "bolt" }} />),
    Bug: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "bug_report" }} />),
    BusinessUnit: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "location_city" }} />),
    Calculate: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "calculate" }} />),
    Calendar: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "date_range" }} />),
    Car: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "directions_car" }} />),
    CheckboxOutline: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "check_box_outline_blank" }} />),
    Checkbox: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "check_box" }} />),
    Circle: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "circle" }} />),
    Unchecked: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "check_box_outline_blank" }} />),
    Checked: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "check_box" }} />),
    Cancel: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "cancel" }} />),
    Clear: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "clear" }} />),
    Close: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "close" }} />),
    Commissions: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "calculate" }} />),
    Company: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "business" }} />),
    Contact: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "person" }} />),
    Copy: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "content_copy" }} />),
    Paste: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "content_paste" }} />),
    Pdf: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "picture_as_pdf" }} />),
    CreditNote: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "card_giftcard" }} />),
    DataGrid: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "table_view" }} />),
    Report: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "insert_chart" }} />),
    Curtain: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "curtains" }} />),
    Delete: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "delete_forever" }} />),
    DepartureBoard: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "departure_board" }} />),
    Done: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "done" }} />),
    Down: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "keyboard_arrow_down" }} />),
    Download: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "download" }} />),
    Upload: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "upload" }} />),
    Edit: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "edit" }} />),
    EmailSmall: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "mail" }} />),
    Email: React.forwardRef((p, ref) => <Icon {...{ ...p, img: "/images/email-icon.png" }} />),
    Eye: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "remove_red_eye" }} />),
    Error: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "error" }} />),
    ExpandContent: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "expand_content" }} />),
    Filter: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "filter_list" }} />),
    Fullscreen: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "fullscreen" }} />),
    FullscreenClose: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "close_fullscreen" }} />),
    Gallery: React.forwardRef((p, ref) => <ReactIcon {...p} iconRef={ref} glyph={TbLibraryPhoto} />),
    Group: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "group" }} />),
    Health: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "local_hospital" }} />),
    History: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "history" }} />),
    Home: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "home" }} />),
    Info: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "info" }} />),
    Invoice: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "receipt" }} />),
    Lead: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "person" }} />),
    Link: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "link" }} />),
    LinkBroken: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "link_off" }} />),
    Location: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "location_on" }} />),
    Map: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "map" }} />),
    Marketing: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "campaign" }} />),
    Message: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "message" }} />),
    MobileChat: React.forwardRef((p, ref) => <Icon {...p} iconRef={ref} img="/images/mobile_sms.png" style={{ width: 24, height: 24 }}/>),
    More: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: p.vertical ? "more_vert" : "more_horiz" }} />),
    New: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "add" }} />),
    Notes: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "note" }} />),
    BackAll: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "first_page" }} />),
    Back: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "arrow_back_ios" }} />),
    ReAssign: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "redo" }} />),
    Recurring: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "autorenew" }} />),
    Forward: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "arrow_forward_ios" }} />),
    FastForward: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "fast_forward" }} />),
    Square: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "square" }} />),
    Toggle: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "list" }} />),
    LiveDiary: React.forwardRef((p, ref) => <Icon {...{ ...p, img: "/images/LDIcon20x20.png" }} />),
    LockClosed: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "lock" }} />),
    LockOpened: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "lock_open" }} />),
    Line: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "/" }} />),
    Order: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "library_books" }} />),
    Chat: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "chat" }} />),
    Payment: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "payment" }} />),
    Phone: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "phone" }} />),
    Plus: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "add" }} />),
    Print: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "print" }} />),
    Quote: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "shopping_cart" }} />),
    Refresh: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "refresh" }} />),
    Remove: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "remove" }} />),
    Save: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "save" }} />),
    Search: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "search" }} />),
    Skill: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "construction" }} />),
    SMSSMall: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "sms" }} />),
    SMS: React.forwardRef((p, ref) => <Icon {...{ ...p, img: "/images/sms-icon.png" }} />),
    Snooze: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "snooze" }} />),
    Spanner: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "build" }} />),
    Sort: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "sort" }} />),
    Split: React.forwardRef((p, ref) => <Icon {...{ ...p, img: "/images/split_icon.png" }} />),
    Support: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "help_outline" }} />),
    Swap: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "swap_horiz" }} />),
    Text: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: p.text }} />),
    Task: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "assignment" }} />),
    ThumbsDown: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "thumb_down" }} />),
    Tracking: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "list_alt" }} />),
    Undo: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "undo" }} />),
    Up: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "keyboard_arrow_up" }} />),
    Visibility: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "visibility" }} />),
    VisibilityOff: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "visibility_off" }} />),
    Warning: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "warning" }} />),
    WarningChanged: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "sync_problem" }} />),
    WhatsNew: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "info" }} />),
    Work: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "work" }} />),
    Workflow: React.forwardRef(({ top, left, style, onClick, disabled, ...rest }, ref) => (
        <div className="acc-icon-containter" ref={ref}>
            <TbLayoutKanban
                size={18}
                style={{
                    position: 'relative',
                    top: top ? `${top}px` : 'unset',
                    left: left ? `${left}px` : 'unset',
                    cursor: disabled ? 'no-drop' : onClick ? 'pointer' : undefined,
                    opacity: disabled ? 0.5 : 1,
                    ...style
                }}
                onClick={disabled ? undefined : onClick}
            />
        </div>
    )),
    WhatsAppIconOnlyWhiteOnGreenSmall: React.forwardRef(({ style, ...p }, ref) => (<Icon {...p} ref={ref} img="/images/whatsapp_glyph_white.png" style={{ backgroundColor:'#25d366', borderRadius: 8, overflow: 'hidden', ...style }}/>)),
    WhatsAppIconAndTextWhiteGreenSmall: React.forwardRef((p, ref) => <Icon {...{ ...p, img: "/images/whatsapp_glyph_texth_white.png" }} style={{ backgroundColor: '#25d366' }} />),
    WhatsAppIconAndTextBelowWhiteGreenSmall: React.forwardRef((p, ref) => <Icon {...{ ...p, img: "/images/whatsapp_glyph_texth_whitev.png" }} style={{ backgroundColor: '#25d366' }} />),
    Unknown: React.forwardRef((p, ref) => <Icon {...{ ...p, iconRef: ref, matrial: "pending" }} />)
}


export default AccentIcons;
